export const newAllPortfolio = [
  {
    id: 1,
    title: "Rabbit Run",
    img: "assets/RabbitRunLogo.png",
    url: "https://brokenpuzzle.itch.io/rabbit-run",
    type: "game",
  },
  {
    id: 2,
    title: "Corn Maize",
    img: "assets/CornMaizeLogo.jpg",
    url: "https://aathompson.itch.io/corn-maize",
    type: "game",
  },
  {
    id: 3,
    title: "Tinder Clone",
    img: "assets/TinderCloneImg.png",
    url: "https://tinder-clone-172fc.web.app/",
    type: "web",
  },
  {
    id: 4,
    title: "Rhythm of the JAM",
    img: "assets/RhythmoftheJAMLogo.png",
    url: "https://brokenpuzzle.itch.io/rhythm-of-the-jam",
    type: "game",
  },
];

export const allPortfolio = [
  {
    id: 1,
    title: "Rabbit Run",
    img: "assets/RabbitRunLogo.png",
    url: "https://brokenpuzzle.itch.io/rabbit-run",
  },
  {
    id: 2,
    title: "Corn Maize",
    img: "assets/CornMaizeLogo.jpg",
    url: "https://aathompson.itch.io/corn-maize",
  },
  {
    id: 3,
    title: "Tinder Clone",
    img: "assets/TinderCloneImg.png",
    url: "https://tinder-clone-172fc.web.app/",
  },
  {
    id: 4,
    title: "Rhythm of the JAM",
    img: "assets/RhythmoftheJAMLogo.png",
    url: "https://brokenpuzzle.itch.io/rhythm-of-the-jam",
    type: "game",
  },
];

export const gamesPortfolio = [
  {
    id: 1,
    title: "Rabbit Run",
    img: "assets/RabbitRunLogo.png",
    url: "https://brokenpuzzle.itch.io/rabbit-run",
  },
  {
    id: 2,
    title: "Corn Maize",
    img: "assets/CornMaizeLogo.jpg",
    url: "https://aathompson.itch.io/corn-maize",
  },
  {
    id: 3,
    title: "Rhythm of the JAM",
    img: "assets/RhythmoftheJAMLogo.png",
    url: "https://brokenpuzzle.itch.io/rhythm-of-the-jam",
    type: "game",
  },
];

export const webPortfolio = [
  {
    id: 1,
    title: "Tinder Clone",
    img: "assets/TinderCloneImg.png",
    url: "https://tinder-clone-172fc.web.app/",
  },
];

export const modelsPortfolio = [];
